import { logEvent } from './utils/logger';
import { updateSubscription } from './utils/trySubscribeToSelfPush';

if ('serviceWorker' in navigator) {
	window.addEventListener('load', async () => {
		try {
			const registration = await navigator.serviceWorker.register(
				import.meta.env.MODE === 'production' ? '/sw.js' : '/dev-sw.js?dev-sw',
				{ type: import.meta.env.MODE === 'production' ? 'classic' : 'module' }
			);

			console.log('Service Worker registered with scope:', registration.scope);
			const sp = new URLSearchParams(window.location.search);
			if (sp.has('swUpdate')) {
				await updateSubscription({});
				sp.delete('swUpdate');
				sp.set('swUpdated', '1');
				window.location.replace(`?${sp.toString()}`);
			}
			registration.addEventListener('updatefound', () => {
				try {
					const newWorker = registration.installing;
					if (!newWorker) return;
					newWorker.addEventListener('statechange', async () => {
						if (sp.has('swUpdated')) return;
						logEvent('Обновление сервис воркера: ' + newWorker.state);
						if (newWorker.state === 'installed') {
							if (navigator.serviceWorker.controller) {
								logEvent('Произошло обновление сервис воркера');
								setTimeout(() => {
									sp.set('swUpdate', '1');
									window.location.href = `?${sp.toString()}`;
								}, 1000);
							}
						}
					});
				} catch (e) {
					logEvent('Не удалось обновить сервис воркер: ' + e);
				}
			});
		} catch (e) {
			logEvent(`Не удалось зарегистрировать сервис воркер: ${e}`);
		}
	});
}
